import { render, staticRenderFns } from "./finDataProtection.vue?vue&type=template&id=be0ad936&scoped=true&"
import script from "./finDataProtection.vue?vue&type=script&lang=js&"
export * from "./finDataProtection.vue?vue&type=script&lang=js&"
import style0 from "./finDataProtection.vue?vue&type=style&index=0&id=be0ad936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0ad936",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
